import operator from './operator'

export default operator
export { default as initialState } from './initialState'
export { default as reducers } from './reducers'
export { default as watchOperations } from './sagas/operations'
